import util from "@/common/js/util";
import constants from "@/common/constants";


const region = {
    async getList() {
        return util.cache({
            key: constants.regionStoreKey,
            fetch: () => util.axios.post('/public/queryAllWorldArea'),
            handle: res => res.module || [],
        });
    },
    async getListByCountry(code) {
        if (!code) {
            return [];
        }
        return util.cache({
            key: constants.regionStoreKey+"_"+code,
            fetch: () => util.axios.post('/public/queryAreaByKey?code='+code),
            handle: res => res.module || [],
        });
    },
}

export default region;



// WEBPACK FOOTER //
// ./src/common/api/region.js